import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import BatteryIcon from "components/Icons/TobarIcons/BatteryIcon";
import { useAppSelector } from "hooks/store/hooks";
import React from "react";
import { selectCurrentDeviceStatusSettings } from "stores/auth/authSlice";
import { selectColorThemeMode } from "stores/ui/uiSlice";

const BatteryIconDropDown = () => {
  const colorThemeMode = useAppSelector(selectColorThemeMode);
  const currentDeviceStatusSettings = useAppSelector(
    selectCurrentDeviceStatusSettings
  );

  return (
    <>
      <Menu
        matchWidth
        isLazya
        lazyBehavior="unmount"
        mb={{ sm: "10px", md: "20px", base: "10px" }}
        p={"10px 0px"}
        h="100%"
        closeOnSelect={false}
      >
        <MenuButton
          as={Button}
          w={{ base: "full", md: "50px" }}
          p={0}
          minW={"10px"}
          h={"50px"}
          borderRadius={"0px"}
          _hover={{ bg: "#00000020" }}
        >
          <Box
            alignItems="center"
            display="flex"
            justifyContent="center"
            gap="1"
          >
            <BatteryIcon />
          </Box>
        </MenuButton>
        <MenuList
          zIndex={1002}
          overflow="hidden"
          right={{ base: "0px", md: "0px" }}
          position={"absolute"}
          minW={{ base: "70px", md: "100px !important" }}
          maxW={{ base: "70px", md: "100px !important" }}
          borderRadius={"4px"}
          marginTop={"-9px"}
          p={0}
          bg={`${colorThemeMode}_background`}
          boxShadow={"1px 1px 15px rgba(0, 0, 0, .1)"}
        >
          <Text></Text>
          <MenuItem
            as={Box}
            h="50px"
            bgColor={`${colorThemeMode}_background`}
            color={`${colorThemeMode}_text`}
            borderTop={"1px solid"}
            borderTopColor={`${colorThemeMode}_tertiary`}
            _hover={{
              color: `${colorThemeMode}_primary`,
              bgColor: `${colorThemeMode}_tertiary`,
            }}
          >
            <Text fontSize={"16px"} fontWeight={"400"}>
              {currentDeviceStatusSettings?.device_status?.batterylevel}
            </Text>
          </MenuItem>
        </MenuList>
      </Menu>
    </>
  );
};

export default BatteryIconDropDown;
